import { createAsyncThunk } from "@reduxjs/toolkit";
import client from "../../../../app/core/client-http/client";
import { downloadBlob } from "../../../../utils/functions/downloadBlob";
import { retrieveStudioId } from "../../../../utils/storage";

export const doUploadLogoFileOnS3 = createAsyncThunk(
  "uploadLogo/personalizza-studio",
  async ({ url, file, type }, thunkAPI) => {
    try {
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": type,
          'X-SelectedAdminStudio': `${retrieveStudioId()}`
        },
        body: file,
      });
      if (response.ok) {
        return response.url;
      } else {
        throw new Error(
          "Errore durante il caricamento del file su Azure Blob Storage"
        );
      }
    } catch (error) {
      throw new Error(error.message);
    }
  }
);

export const getUploadLogoURL = createAsyncThunk(
  "createStudio/getUploadLogoURL",
  async () => {
    const endpoint = "/admin/studio/getuploadurl";
    const response = await client.get(endpoint);
    return response.data;
  }
);



export const doReportOperator = createAsyncThunk(
  "operatorManagement/get-report-operator",
  async (reportOperatorData, thunkAPI) => {
    const endpoint = "/admin/commercialista/export";
    const response = await client.get(endpoint, null, { type: "blob" });
    downloadBlob("Report operatore.xls", response);
  }
);
